import type { LevelDefinition } from './Level.ts';

/**
 * Level 2 — aim.
 *
 * The divider has two doors. The right one is closer to the goal and leads into a sealed
 * box; the left one is the way through. Put a positive magnet on the goal and the fluid
 * takes the obvious door and is never seen again.
 *
 * The fix is the second magnet, flipped negative and parked to the right of the source.
 * It does not block anything — it launches. A negative magnet behind the fluid pushes it
 * away from itself, so where you stand it decides which way the stream leaves, and from
 * there the walls and the goal magnet do the rest.
 */
export const level02: LevelDefinition = {
  id: 'level02',
  name: 'Two doors',
  hint: 'Tap a magnet to flip it. A negative magnet behind the fluid aims it.',
  magnetsAvailable: 2,
  fluid: {
    amount: 380,
    source: { x: 500, y: 400 },
    radius: 44,
  },
  goal: { x: 740, y: 1270, radius: 120, type: 'fluid', fraction: 0.45 },
  walls: [
    // Arena.
    { type: 'segment', x1: 120, y1: 240, x2: 880, y2: 240, thickness: 26 },
    { type: 'segment', x1: 880, y1: 240, x2: 880, y2: 1400, thickness: 26 },
    { type: 'segment', x1: 880, y1: 1400, x2: 120, y2: 1400, thickness: 26 },
    { type: 'segment', x1: 120, y1: 1400, x2: 120, y2: 240, thickness: 26 },

    // The divider, with a door at each end.
    { type: 'segment', x1: 120, y1: 880, x2: 210, y2: 880, thickness: 26 },
    { type: 'segment', x1: 340, y1: 880, x2: 640, y2: 880, thickness: 26 },
    { type: 'segment', x1: 770, y1: 880, x2: 880, y2: 880, thickness: 26 },

    // The sealed box under the right-hand door.
    { type: 'segment', x1: 620, y1: 880, x2: 620, y2: 1090, thickness: 26 },
    { type: 'segment', x1: 620, y1: 1090, x2: 810, y2: 1090, thickness: 26 },
    { type: 'segment', x1: 810, y1: 1090, x2: 810, y2: 880, thickness: 26 },
  ],
};
